import Component from './src/index.vue';

export default Component;
